import { PLACEHOLDER_IMAGE_URL } from '../constants';

export default class UserModel {
    id: number | null = null;
    uuid: string | null = null;
    full_name: string | null = null;
    phone: string | null = null;
    email: string | null = null;
    picture: any = null;

    constructor(data?: any) {
        this.id = data?.id;
        this.uuid = data?.uuid;
        this.full_name = data?.full_name;
        this.phone = data?.phone;
        this.email = data?.email;
        this.picture = data?.picture ?? null;
    }

    getFullName(): string {
        return this.full_name ?? '';
    }

    getAvatarUrl(): string {
        return this.picture?.url ?? PLACEHOLDER_IMAGE_URL;
    }
}
